exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".input {\n  display: block;\n  margin: 0;\n  padding: 0 0 0.15em;\n  width: 100%;\n  border: none;\n  border-bottom: 2px solid #aaa;\n  background-color: transparent;\n  color: #fffed8;\n  text-overflow: ellipsis;\n  font-weight: bold;\n  font-size: 50px;\n  border-radius: 0; }\n  .input:invalid {\n    box-shadow: none; }\n  .input:focus {\n    outline: 0; }\n  .input::placeholder {\n    color: #222; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/layout/Input/index.scss
// module id = 1099
// module chunks = 0